import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GetPaymentResultDTO } from '../api/@types/GetPaymentResultDTO'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { formatAmount } from '@src/services/Formatter';

interface PaymentStatusProps {
  paymentInfo: GetPaymentResultDTO | null
}

const PaymentStatus: FC<PaymentStatusProps> = ({ paymentInfo }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column'}}> 
     <Stack direction="row" spacing={1} alignItems="center" sx={{ marginBottom: 2 }}>
        <NotificationsActiveIcon color="action" />
        <Typography>{t('payment.attention')}</Typography>
      </Stack>
      {paymentInfo && (
      <Box key={paymentInfo.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>  
      <Stack
        direction="row"
        spacing={2}  
        justifyContent="space-between"
        alignItems="center"
        sx={{ fontWeight: 200 ,mb:2,mt:2 }}
      >
        <Typography variant="body2">  
        <Typography variant="body2" sx={{ mb: 0.1, mt:1 , fontWeight: 200 ,}}>   {t('payment.paymentBefore')}</Typography><br />
          <Box component="span" sx={{ fontSize: '2rem', color: 'white' }}>{formatAmount(paymentInfo.amount).dollars}</Box>
          <Box component="span" sx={{ fontSize: '2rem', color: 'gray' }}>.{formatAmount(paymentInfo.amount).cents}$</Box>
          <Box component="span" sx={{fontSize: '0.9rem', color: 'gray' }}> / {t('payment.month')}</Box>
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
                {t('payment.paymentAfter')}<br />
                <Box component="span" sx={{ color: 'gray', fontWeight: 200  }}>{t('payment.contactForChanges')}</Box>
         </Typography>
      </Stack>
      </Box>
      )}
    </Box>
  )
}

export default PaymentStatus